export default "__VITE_ASSET__BLnYaO2V__"